// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d978a5bc","488":"43e9be7b"}[chunkId] + ".chunk.js";
};